<template>
    <MenuDropDown
        :items="regions"
        :label="regionCode"
        class="menu-drop-down"
        :class="classSwitcher"
        @select="goToRegion(regions[$event]?.value.code)"
    />
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router'
import {
    getRoutingRegion,
    useRegionPlugin,
    useRegionSelectOptions,
} from '@/plugins/region'
import type { RegionCode } from '@/graphql/api'

import MenuDropDown from '@/components/ui/menus/MenuDropDown.vue'
import { computed } from 'vue'

const { isInFooter } = defineProps<{
    isInFooter?: boolean
}>()

const router = useRouter()
const { selectAndPersistRegion, regionCode } = useRegionPlugin()

const regions = useRegionSelectOptions()

const goToRegion = (region: RegionCode | undefined) => {
    if (!region) {
        return
    }

    selectAndPersistRegion(region).then(() =>
        router.push({
            ...router.currentRoute.value,
            // @ts-expect-error alabala
            params: {
                ...router.currentRoute.value.params,
                region: getRoutingRegion(region),
            },
        })
    )
}

const classSwitcher = computed(() => ({
    'in-footer': isInFooter,
}))
</script>

<style lang="scss" scoped>
.menu-drop-down {
    &.in-footer {
        background: $stone-3;

        :deep(.menu-button) {
            color: $slate;
        }

        :deep(.menu) {
            // right: 0;
            // left: auto;

            background: $stone-2;

            .item {
                color: $slate;

                &:focus {
                    color: rgba($slate, 0.7);
                }

                @include hover() {
                    color: rgba($slate, 0.7);
                }
            }
        }
    }

    @include min-width(1024) {
        &:not(.in-footer) {
            :deep(.menu) {
                right: 0;
                left: auto;
                top: 30px;
                bottom: initial;
            }
        }
    }

    @include min-width(1024) {
        background: $stone-2;

        :deep(.menu-button) {
            color: $slate;
        }

        :deep(.menu) {
            background: $stone-2;

            .item {
                color: $slate;

                &:focus {
                    color: rgba($slate, 0.7);
                }

                @include hover() {
                    color: rgba($slate, 0.7);
                }
            }
        }
    }
}
</style>
